import { render, staticRenderFns } from "./topBExternalLink.vue?vue&type=template&id=feda15d0&scoped=true&"
import script from "./topBExternalLink.vue?vue&type=script&lang=js&"
export * from "./topBExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./topBExternalLink.vue?vue&type=style&index=0&id=feda15d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feda15d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VImg,VRow})
